"use client";

import styles from "./ConfirmResetPasswordFormHeader.module.scss";
import { useTranslations } from "@/i18n";

/**
 * ConfirmResetPasswordFormHeader Component
 *
 * Header section for confirm password reset form with title and instructions.
 * Provides clear guidance for users on the password reset process.
 */
export const ConfirmResetPasswordFormHeader = () => {
  const t = useTranslations("resetPassword.formHeader");

  return (
    <div className={styles["comp"]}>
      {/* Main heading with emphasis on "Confirm" */}
      <h1
        className={styles["comp__header"]}
        dangerouslySetInnerHTML={{ __html: t.raw("title") }}
      />

      {/* Instructions for user */}
      <div className={styles["comp__subtitle"]}>{t("subtitle")}</div>
    </div>
  );
};
